// src/data/learningLinks.js

const learningLinks = {
  'idea-generation': {
    title: '📘 Learn Idea Generation Techniques',
    videoId: 'idea101', // YouTube ID or internal video ID
  },
  'market-research': {
    title: '🔍 Master Market Research Frameworks',
    videoId: 'market201',
  },
  'business-model-builder': {
    title: '📦 Understand Business Model Canvas',
    videoId: 'bmc301',
  },
  'ai-testing': {
    title: '🤖 Validate Your Idea with AI Testing',
    videoId: 'ai401',
  },
  'mvp-planner': {
    title: '🧪 Build an MVP that Works',
    videoId: 'mvp501',
  },
  'gtm-accelerator': {
    title: '🚀 Learn Go-to-Market Strategies',
    videoId: 'gtm601',
  },
};

export default learningLinks;
